import { ChevronLeft, ChevronRight, ZoomIn, ZoomOut, Maximize2, Minimize2, Download } from "lucide-react";

const Btn = ({ children, testid, ...props }) => (
  <button data-testid={testid} {...props}
    className="h-10 min-w-10 px-3 grid place-items-center border border-[#F5A524]/40 text-[#F5A524] hover:bg-[#F5A524] hover:text-black active:scale-95 disabled:opacity-30 disabled:pointer-events-none transition-[background-color,color,transform]">
    {children}
  </button>
);

export const FlipControls = ({ label, canPrev, canNext, onPrev, onNext, zoom, setZoom, full, toggleFull, src }) => (
  <div className="flex flex-wrap items-center justify-between gap-3 px-4 sm:px-5 py-3 border-t border-[#F5A524]/20 font-mono text-[11px] tracking-[0.2em]">
    <div className="flex items-center gap-2">
      <Btn testid="flip-prev-btn" onClick={onPrev} disabled={!canPrev} aria-label="Previous page"><ChevronLeft size={18} /></Btn>
      <span data-testid="flip-page-indicator" className="min-w-[88px] text-center text-white">{label}</span>
      <Btn testid="flip-next-btn" onClick={onNext} disabled={!canNext} aria-label="Next page"><ChevronRight size={18} /></Btn>
    </div>
    <div className="flex items-center gap-2">
      <Btn testid="flip-zoom-out-btn" onClick={() => setZoom((z) => Math.max(1, z - 0.5))} disabled={zoom <= 1} aria-label="Zoom out"><ZoomOut size={16} /></Btn>
      <span data-testid="flip-zoom-level" className="w-12 text-center text-zinc-300">{Math.round(zoom * 100)}%</span>
      <Btn testid="flip-zoom-in-btn" onClick={() => setZoom((z) => Math.min(3, z + 0.5))} disabled={zoom >= 3} aria-label="Zoom in"><ZoomIn size={16} /></Btn>
      <Btn testid="flip-fullscreen-btn" onClick={toggleFull} aria-label="Fullscreen">{full ? <Minimize2 size={16} /> : <Maximize2 size={16} />}</Btn>
      <a data-testid="pdf-download-btn" href={src} download aria-label="Download PDF"
        className="h-10 px-3 flex items-center gap-2 bg-[#F5A524] text-black hover:bg-white transition-colors">
        <Download size={15} /> <span className="hidden sm:inline">PDF</span>
      </a>
    </div>
  </div>
);

export const Thumbs = ({ count, thumbs, visible, onPick }) => (
  <div data-lenis-prevent className="flex gap-2 overflow-x-auto px-4 sm:px-5 py-3 border-t border-[#F5A524]/20">
    {Array.from({ length: count }, (_, i) => i + 1).map((n) => (
      <button key={n} data-testid={`flip-thumb-${n}`} onClick={() => onPick(n)} aria-label={`Page ${n}`}
        className={`relative shrink-0 h-20 w-14 bg-[#0B0C10] border transition-[border-color,transform] hover:-translate-y-0.5 ${visible.includes(n) ? "border-[#F5A524]" : "border-white/10 hover:border-[#F5A524]/60"}`}>
        {thumbs[n] && <img src={thumbs[n]} alt="" className="w-full h-full object-cover" />}
        <span className="absolute bottom-0 inset-x-0 bg-black/75 font-mono text-[10px] text-zinc-300">{String(n).padStart(2, "0")}</span>
      </button>
    ))}
  </div>
);
